import Loader from '../../components/Loader'
import React from 'react'
import cx from 'classnames'
import styles from './OrderList.module.css'
import { Order } from '../../types/Order'
import { useTranslation } from 'react-i18next'

const OrderList: React.FC<{
    showCustomization: (customization: [number, string] | null) => void
    orders: Order[]
    isLoading: boolean
    detailList: number[]
    changeDetailList: (order_id: number) => void
}> = ({
    showCustomization,
    orders,
    isLoading,
    detailList,
    changeDetailList,
}) => {
    const { t } = useTranslation(['orders'])

    return (
        <div>
            {isLoading && (
                <div className={'zr-w-100 zr-d-flex zr-justify-center'}>
                    <Loader size={'m'} isLoading={isLoading} />
                </div>
            )}
            {orders.length > 0 && (
                <table className={cx(styles['zr-table'])}>
                    <thead className={cx(styles['table-header'])}>
                        <tr>
                            <th>
                                <strong>{t('order_nr')}</strong>
                            </th>
                            <th>
                                <strong>{t('customer')}</strong>
                            </th>
                            <th>
                                <strong>{t('date')}</strong>
                            </th>
                            <th>
                                <strong>{t('state')}</strong>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order: Order) => {
                            return (
                                <React.Fragment key={order.id}>
                                    <tr
                                        className={'zr-cursor-pointer'}
                                        key={order.id}
                                        onClick={() =>
                                            changeDetailList(order.id)
                                        }
                                    >
                                        <td>{order.number}</td>
                                        <td>
                                            <span
                                                className={'zr-mr-1'}
                                                dangerouslySetInnerHTML={{
                                                    __html: order.customer
                                                        .firstname,
                                                }}
                                            />
                                            &nbsp;
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: order.customer
                                                        .lastname,
                                                }}
                                            />
                                        </td>
                                        <td>{order.datetime}</td>
                                        <td>{order.status}</td>
                                    </tr>
                                    {detailList.includes(order.id) && (
                                        <tr>
                                            <td
                                                colSpan={4}
                                                className={'zr-ml-4'}
                                            >
                                                <ul>
                                                    {order.customizations.map(
                                                        (c) => {
                                                            return (
                                                                <li key={c.id}>
                                                                    <u
                                                                        className={
                                                                            'zr-cursor-pointer'
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: c.article,
                                                                        }}
                                                                        onClick={() =>
                                                                            showCustomization(
                                                                                [
                                                                                    c.id,
                                                                                    c.article,
                                                                                ]
                                                                            )
                                                                        }
                                                                    />
                                                                </li>
                                                            )
                                                        }
                                                    )}
                                                </ul>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default OrderList
